<nav class="navbar d-lg-none navbar-light bg-white shadow-sm px-3" [class.fixed-header]="isHeaderFixed">
  <button class="btn btn-mobile text-white f-24" (click)="toggleSidebar()">
    ☰
  </button>
  <a [routerLink]="['/refund']" [queryParams]="{action: 'history'}">
    <img [src]="brandService.theme.logoUrl" [alt]="brandService.theme.name + ' Logo'"
      style="width: 160px; height: 58px; object-fit: contain;" />
  </a>
</nav>

<div class="overlay" *ngIf="isSidebarOpen" (click)="toggleSidebar()"></div>

<div class="sidebar" [class.active]="isSidebarOpen">
  <div class="logo mt-lg-3">
    <a [routerLink]="['/refund']" [queryParams]="{action: 'history'}">
      <img [src]="brandService.theme.logoUrl" [alt]="brandService.theme.name + ' Logo'"
        style="width: 160px; height: 58px; object-fit: contain; filter: brightness(0) invert(1);" />
    </a>
  </div>

  <ul class="icon">
    <li>
      <a [routerLink]="['/refund']" [queryParams]="{action: 'manage'}" routerLinkActive="active">
        <img src="https://res.cloudinary.com/pervolare-org/image/upload/v1760565541/TAS/rutt/sidebar/refunds_qxhg0o.svg"
          alt="icon" />
        Solicitar reembolso
      </a>
    </li>

    <li>
      <a routerLink="/contact" routerLinkActive="active">
        <img src="https://res.cloudinary.com/pervolare-org/image/upload/v1760565009/TAS/rutt/sidebar/contact_jjpec2.svg"
          alt="icon" />
        Contacto TAS
      </a>
    </li>

    <li>
      <a routerLink="/faq" routerLinkActive="active">
        <img src="https://res.cloudinary.com/pervolare-org/image/upload/v1760565095/TAS/rutt/sidebar/fq_djr1xw.svg"
          alt="icon" />
        Preguntas frecuentes
      </a>
    </li>

    <li>
      <a [href]="this.brandService.theme.name == 'Pervolare' ? '/docs/Contract-PERVOLARE.pdf': '/docs/Contract-TAS.pdf'"
        target="_blank" rel="noopener noreferrer">
        <img
          src="https://res.cloudinary.com/pervolare-org/image/upload/v1760565229/TAS/rutt/sidebar/conditions-of-use_kec3ud.svg"
          alt="icon" />
        Condiciones de Uso
      </a>
    </li>

    <li>
      <a href="https://traveler-assistance.com/politicas-de-privacidad" target="_blank" rel="noopener noreferrer">
        <img
          src="https://res.cloudinary.com/pervolare-org/image/upload/v1760565347/TAS/rutt/sidebar/privacy-policies_ski28u.svg"
          alt="icon" />
        Política de privacidad
      </a>
    </li>
  </ul>
</div>